<template>
    <vTransactionConfigComponent :postList="postList" v-if="flag"></vTransactionConfigComponent>
</template>
<script>
import vTransactionConfigComponent from '../../listComponent/basicdata/transactionConfig/transactionConfigComponent.vue';
export default {
    name: 'vTransactionConfig',
    components: {
        vTransactionConfigComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                supplier_rid: true,
                demander_rid: true,
                partner_rid: true,
                product_rid: true,
                promotion_type: true,
                status: true,
                date: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true,
                matchBtn: true,
                syncFromSfBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>